/* ==========================================================
   NUAGE – Quick View (Minimog) – V3
   ملف: assets/nuage-quickview.js  (استبدلي القديم بالكامل)
   جديد: ألوان المكونات الحقيقية + صور اختيارية
   ========================================================== */
(function () {
  var SELECTOR = '.m-product-quickview';

  /* ---------- 1) ألوان المكونات (الكلمة بتتدور عليها جوه الاسم) ---------- */
  var TONES = [
    ['strawberry', '#E0405F'], ['raspberry', '#C2255C'], ['blackberry', '#5A3470'],
    ['black currant', '#4B2A63'], ['blackcurrant', '#4B2A63'], ['cherry', '#B31B3C'],
    ['berry', '#B0305A'], ['mandarin', '#F29A1F'], ['orange', '#F28C1B'], ['bergamot', '#C9D24A'],
    ['lemon', '#F2D230'], ['lime', '#8FC23E'], ['grapefruit', '#F2766B'], ['citrus', '#F4C430'],
    ['apple', '#9CC84B'], ['pear', '#C9D77B'], ['peach', '#F7A98B'], ['pineapple', '#F1C93B'],
    ['coconut', '#EADFCB'], ['melon', '#B9DE8D'],
    ['spearmint', '#6CC49A'], ['mint', '#5CC0A0'], ['basil', '#5E9E55'], ['green', '#6DB06B'],
    ['lavender', '#9C84D4'], ['violet', '#8458B8'], ['iris', '#8E7CC3'], ['jasmine', '#EFE3C4'],
    ['rose', '#E06A8E'], ['peony', '#F0A0BA'], ['lily', '#F5E9DA'], ['orchid', '#B66CC0'],
    ['floral', '#E88DAE'], ['tuberose', '#F3E6D2'],
    ['cedar', '#8A6444'], ['sandalwood', '#C79A6B'], ['sandal', '#C79A6B'], ['oud', '#4E3626'],
    ['patchouli', '#6B5A3A'], ['vetiver', '#7A8A4A'], ['woody', '#9C7350'], ['wood', '#9C7350'],
    ['oak', '#7B5A3A'], ['pine', '#4F7A5A'], ['moss', '#6E8F5A'],
    ['vanilla', '#E6CC98'], ['tonka', '#B8895A'], ['caramel', '#C98B3E'], ['honey', '#E3A834'],
    ['amber', '#D98E2B'], ['ambroxan', '#B9CFE4'], ['cashmeran', '#C4A07E'], ['musk', '#D6CDE2'],
    ['leather', '#7A4B34'], ['tobacco', '#8A5A2B'], ['coffee', '#5B3A29'], ['chocolate', '#5A3A2E'],
    ['cinnamon', '#B5651D'], ['pepper', '#7A6A62'], ['cardamom', '#A3A878'], ['ginger', '#D9A441'],
    ['saffron', '#E27A1E'], ['incense', '#A99C90'], ['salt', '#BFD6E4'], ['marine', '#6FB4D8'],
    ['freesia', '#F3E3B5'], ['gardenia', '#F6EFE3'], ['magnolia', '#F1D9E4'], ['nectarine', '#F4A261'],
    ['fruity', '#EE8E7A'], ['mediterranean', '#E9A23B'], ['crystallized', '#E9C46A'], ['oakmoss', '#6E8F5A'],
    ['sea', '#6FB4D8'], ['aquatic', '#6FB4D8'], ['water', '#8CC8E8'], ['ozonic', '#B7DCEF']
  ];

  /* ---------- 2) صور المكونات ----------
     الصور في Assets باسم:  note-<المكون>.<امتداد>
     مثال: note-lemon.jpg.png  /  note-black-currant.jpg.png
     (حروف صغيرة وشرطة بدل المسافة في اسم الملف).
     اكتبي الاسم هنا بأي شكل (كابيتال أو مسافات) والكود بيظبطه.   */
  var PHOTO_EXTS = ['jpg.png', 'jpg', 'png', 'webp', 'jpeg ','jpg.jpg'];
  var PHOTO_KEYS = [
    'strawberry', 'blackberry', 'sour-cherry', 'mandarin-orange', 'lemon',
    'violet', 'jasmine', 'musk', 'vanilla', 'cashmeran', 'woody',
    'amber', 'ambroxan', 'apple', 'bergamot', 'black-currant', 'calabrian-bergamot',
    'caramelized-notes', 'cedarwood', 'crystallized', 'freesia', 'fruity-notes', 'gardenia',
    'green-mandarin', 'lavender', 'lily-of-the-valley', 'magnolia', 'mediterranean-fruits',
    'moss-notes', 'nectarine', 'oakmoss', 'patchouli', 'rose', 'saffron',
    'sicilian-orange', 'sandalwood', 'spearmint', 'caramel-popcorn'
  ];

  function slugify(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  /* الأطول الأول، عشان calabrian-bergamot تتجرب قبل bergamot */
  var KEYS = PHOTO_KEYS.map(slugify).filter(Boolean)
    .filter(function (k, i, a) { return a.indexOf(k) === i; })
    .sort(function (x, y) { return y.length - x.length; });

  var cs = document.currentScript;
  var BASE = '';
  if (cs && cs.src) BASE = cs.src.replace(/[^\/]*$/, '');
  if (!BASE) {
    var lk = document.querySelector('link[href*="nuage-quickview"]');
    if (lk) BASE = lk.href.replace(/[^\/]*$/, '');
  }

  var photoCache = {};   /* key -> url أو '' لو مفيش */

  /* بيجرب الامتدادات واحد ورا التاني لحد ما يلاقي الصورة */
  function findPhoto(key, done) {
    if (photoCache.hasOwnProperty(key)) {
      if (photoCache[key] && photoCache[key].then) { photoCache[key].then(done); }
      else { done(photoCache[key]); }
      return;
    }
    photoCache[key] = { then: null };
    var waiting = [done];
    photoCache[key] = { then: function (cb) { waiting.push(cb); } };
    var i = 0;
    (function next() {
      if (i >= PHOTO_EXTS.length) {
        photoCache[key] = '';
        if (window.console && console.info) console.info('[Nuage] مفيش صورة بالاسم: note-' + key + '.*  (راجعي اسم الملف في Assets)');
        waiting.forEach(function (cb) { cb(''); });
        return;
      }
      var url = BASE + 'note-' + key + '.' + PHOTO_EXTS[i++];
      var im = new Image();
      im.onload = function () {
        photoCache[key] = url;
        waiting.forEach(function (cb) { cb(url); });
      };
      im.onerror = next;
      im.src = url;
    })();
  }

  function norm(s) { return (s || '').toLowerCase().trim(); }

  function paintChip(chip) {
    if (chip.getAttribute('data-nq-tone')) return;
    chip.setAttribute('data-nq-tone', '1');
    var nameEl = chip.querySelector('.nq-chip__name');
    var name = norm(nameEl && nameEl.textContent);
    if (!name) return;

    for (var i = 0; i < TONES.length; i++) {
      if (name.indexOf(TONES[i][0]) !== -1) {
        chip.style.setProperty('--tone', TONES[i][1]);
        break;
      }
    }
    var ico = chip.querySelector('.nq-chip__ico');
    if (!ico || !BASE) return;

    var slug = slugify(name);
    var matches = KEYS.filter(function (k) { return slug.indexOf(k) !== -1; });
    var m = 0;
    (function tryNext() {
      if (m >= matches.length) return;
      findPhoto(matches[m++], function (url) {
        if (url) {
          ico.classList.add('is-photo');
          ico.style.setProperty('--photo', 'url("' + url + '")');
        } else {
          tryNext();
        }
      });
    })();
  }

  function paintNotes() {
    var chips = document.querySelectorAll('.nq-chip:not([data-nq-tone])');
    for (var i = 0; i < chips.length; i++) paintChip(chips[i]);
  }

  /* ---------- 3) زرار الإضافة (زي ما هو) ---------- */
  function fx(btn, cx, cy) {
    var r = btn.getBoundingClientRect();
    var rp = document.createElement('span');
    rp.className = 'nq-ripple';
    rp.style.left = (cx - r.left) + 'px';
    rp.style.top = (cy - r.top) + 'px';
    btn.appendChild(rp);
    setTimeout(function () { rp.remove(); }, 750);

    for (var i = 0; i < 4; i++) {
      var p = document.createElement('span');
      var s = 10 + Math.random() * 12;
      p.className = 'nq-puff';
      p.style.width = s + 'px';
      p.style.height = s + 'px';
      p.style.left = (r.width * (0.1 + 0.8 * Math.random())) + 'px';
      p.style.setProperty('--dx', ((Math.random() - 0.5) * 50) + 'px');
      p.style.animationDelay = (i * 60) + 'ms';
      btn.appendChild(p);
      (function (el) { setTimeout(function () { el.remove(); }, 1200); })(p);
    }
  }

  function enhance(root) {
    if (root.getAttribute('data-nq-ready')) return;
    root.setAttribute('data-nq-ready', '1');

    var btn = root.querySelector('button[name="add"]');
    if (!btn) return;

    /* مش بنلمس محتوى الزرار (عشان مانتعارضش مع سبينر الثيم) */
    btn.addEventListener('click', function (e) {
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      var cx = e.clientX, cy = e.clientY;

      /* نوقف الحركات الزخرفية مؤقتًا وقت الإضافة */
      root.classList.add('nq-busy');
      clearTimeout(root._nqBusy);
      root._nqBusy = setTimeout(function () { root.classList.remove('nq-busy'); }, 1600);

      /* التأثير بعد ما كود الثيم يشتغل أول */
      requestAnimationFrame(function () { fx(btn, cx, cy); });

      if (btn.classList.contains('nq-added')) return;
      btn.classList.add('nq-added');
      setTimeout(function () { btn.classList.remove('nq-added'); }, 1800);
    });
  }

  function scan() {
    var found = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < found.length; i++) enhance(found[i]);
    paintNotes();
  }

  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  scan();
})();